import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEMiniFormEditButton, FHETextField, FHEReactSelect, FormEditButton } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import memoizeOne from 'memoize-one';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { ApplianceIconComponent } from 'data/common/iconsvg';
import { updateProductModule, updateProductModuleLabel, updateSDM20LHTConfig } from '../../../../../../data/Products/actions';

class SDM22MMBOutput extends Component {
    static propTypes = {
        enumProductModulesTypes: PropTypes.array.isRequired,
        updateRelayRights: PropTypes.bool.isRequired,
        updateRights: PropTypes.bool.isRequired,
        product: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        module: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        productType: PropTypes.string,
        code: PropTypes.string,
        fheCenter_mac: PropTypes.string,
        updateProductModule: PropTypes.func.isRequired,
        updateProductModuleLabel: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        type: PropTypes.string,
    };

    static defaultProps = {
        fheCenter_mac: null,
        productType: null,
        code: null,
        type: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            labelDisabled: true,
            moduleTypeDisabled: true,
            textInput_error: {},
            sendLabelLoading: false,
            moduleType: null,
            label: null,
            diversityDisabled: true,
            formDisabled: true,
            diversityLoading: false,
            typeDiversity: '',
        };
        this.typeDiversities = [
            { label: Translator.translate('general.productModules.typeDiversity.11a5'), value: '11a5' },
            {
                label: Translator.translate('general.productModules.typeDiversity.label'),
                value: Translator.translate('general.productModules.typeDiversity.label'),
            },
            { label: Translator.translate('general.productModules.typeDiversity.2324'), value: '2324' },
        ];
    }

    componentDidMount() {
        this.loadInputs();
    }

    handleEditLabel = () => {
        const { labelDisabled } = this.state;

        this.setState({
            labelDisabled: !labelDisabled,
        });
    };

    handleEditDiversity = () => {
        const { diversityDisabled } = this.state;

        this.setState({
            diversityDisabled: !diversityDisabled,
        });
    };

    handleChangeLabelWithVerification = event => {
        const { textInput_error, label } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255,
        };

        let newTextInput_error = tools.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = label;
        if (targetValue === '') targetValue = null;

        this.setState({
            [event.target.name]: targetValue,
            textInput_error: newTextInput_error,
        });
    };

    loadInputs = () => {
        const { module } = this.props;
        this.setState({
            formDisabled: true,
            labelDisabled: true,
            textInput_error: {},
            sendLabelLoading: false,
            label: module.get('label'),
            moduleType: module.get('moduleType'),
            typeDiversity: module.get('typeDiversity'),
        });
    };

    confirmEditLabel = () => {
        const { label } = this.state;
        const { updateProductModuleLabel, match, code, type, fheCenter_mac } = this.props;

        this.setState({
            sendLabelLoading: true,
            labelDisabled: true,
        });

        return updateProductModuleLabel(fheCenter_mac, match.params.productIdentifier, match.params.productType, type, code, label)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                this.loadInputs();
            })
            .catch(error => {
                this.setState({
                    sendLabelLoading: false,
                    labelDisabled: false,
                });
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${error.message ? error.message : error}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.products.actions.editProductModuleError`),
                );
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                }
            });
    };

    confirmEditDiversity = () => {
        const { typeDiversity, output } = this.state;
        const { module, match, updateSDM20LHTConfig, fheCenter_mac } = this.props;

        this.setState({ diversityLoading: true });

        return updateSDM20LHTConfig(
            fheCenter_mac,
            match.params.homeId,
            match.params.productType,
            match.params.productIdentifier,
            typeDiversity,
            output,
            module.get('code'),
        )
            .then(() => {
                this.loadInputs();
                this.setState({ diversityLoading: false, diversityDisabled: true });
            })
            .catch(() => {
                this.setState({
                    diversityLoading: false,
                    diversityDisabled: false,
                });
                Toastr.error(Translator.translate(`generic.products.actions.editProductModuleError`));
            });
    };

    getSelectedType = memoizeOne(type => {
        const { enumProductModulesTypes } = this.props;
        return enumProductModulesTypes.find(x => x.value === type);
    });
    getSelectedTypeDiversity = memoizeOne(diversity => {
        if (this.typeDiversities.find(x => x.value === diversity)) {
            return diversity;
        } else if (diversity !== null) {
            this.typeDiversities.push({ label: diversity, value: diversity });
            return this.typeDiversities.find(x => x.value === diversity);
        } else {
            return this.typeDiversities.find(x => x.value === Translator.translate('general.productModules.typeDiversity.label'));
        }
    });

    handleReactSelect = event => {
        this.setState({
            moduleType: event.value,
        });
    };
    handleSelectDiversity = event => {
        this.setState({
            typeDiversity: event.value,
        });
    };

    renderModuleDetails = module => {
        const { productType = '', code = '', favorite = '' } = module.toJSON();
        const { updateRights, enumProductModulesTypes } = this.props;
        const {
            labelDisabled,
            textInput_error,
            sendLabelLoading,
            diversityDisabled,
            typeDiversity,
            moduleType,
            label,
            diversityLoading,
            formDisabled,
        } = this.state;

        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    {/*label*/}
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEMiniFormEditButton
                            handleEdit={this.handleEditLabel}
                            confirmEdit={this.confirmEditLabel}
                            sendLoading={sendLabelLoading}
                            formDisabled={labelDisabled}
                            hasRightToEdit={updateRights}
                        >
                            <FHETextField
                                disabled={labelDisabled}
                                id="label"
                                value={!label || label === null ? '' : label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeLabelWithVerification}
                            />
                        </FHEMiniFormEditButton>
                    </Grid>
                    {/*moduleType*/}
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEReactSelect
                            name="moduleType"
                            label={Translator.translate('general.table.column.moduleType')}
                            disabled={formDisabled}
                            onChange={this.handleReactSelect}
                            value={this.getSelectedType(moduleType)}
                            choices={enumProductModulesTypes}
                        />
                    </Grid>
                    {/*productType*/}
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.productType')}
                            itemContent={Translator.translate(`general.productModules.${productType}`)}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    {/*typeDiversity*/}
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEMiniFormEditButton
                            handleEdit={this.handleEditDiversity}
                            confirmEdit={this.confirmEditDiversity}
                            sendLoading={diversityLoading}
                            formDisabled={diversityDisabled}
                            hasRightToEdit={updateRights}
                        >
                            <FHEReactSelect
                                name="typeDiversity"
                                label={Translator.translate('general.productModules.typeDiversity.label')}
                                disabled={diversityDisabled}
                                onChange={this.handleSelectDiversity}
                                value={this.getSelectedTypeDiversity(typeDiversity)}
                                choices={this.typeDiversities}
                            />
                        </FHEMiniFormEditButton>
                    </Grid>
                    {/*code*/}
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.favorite')}
                            itemContent={Translator.translate(`general.productModules.${favorite}`)}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    };

    renderExpansionPanel = module => {
        const { theme, product, classes } = this.props;
        return (
            <ExpansionPanel key={module.get('code')}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <ApplianceIconComponent productModule={product} color={theme.palette.primary.main} size={30} />
                    <span className={classes.accordionTitle}>{module.get('label')}</span>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>{this.renderModuleDetails(module)}</ExpansionPanelDetails>
            </ExpansionPanel>
        );
    };

    render() {
        const { module } = this.props;
        return this.renderExpansionPanel(module);
    }
}

function mapStateToProps(state, props) {
    const { history, module } = props;
    const profile = state.data.user;
    const updateRights = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`products_SDM20LHT_update`);
    const updateRelayRights =
        profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`productModules_SDM20LHT_relay_update`);

    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === module.get('homeId')) fheCenter_mac = macAddress;
    });
    const enums = state.environments[history.environment].enums;
    return {
        enumProductModulesTypes: enums.productModulesTypes || [],
        profile,
        updateRights,
        updateRelayRights,
        fheCenter_mac,
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20,
    },
    detailPanelContainer: {
        marginTop: 10,
        marginBottom: -5,
    },
    accordionTitle: {
        paddingLeft: 10,
        color: theme.palette.common.black,
    },
});
export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/SDM22MMB/SDM22MMBOutput',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductModule,
                        updateProductModuleLabel,
                        updateSDM20LHTConfig,
                    }),
                    dispatch,
                ),
        )(withStyles(styles, { withTheme: true })(SDM22MMBOutput)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM22MMB/SDM22MMBOutput.js